<template>
    <p class="bold-paragraph-text" v-html="content"></p>
</template>

<script>
export default {
    name: 'BoldParagraphText',
    props: {
        content: String,
    },
};
</script>
<style>
.bold-paragraph-text {
    font-size: 16px;
    line-height: 140%;
    font-weight: bold;
}
</style>
